import React, { useCallback } from "react";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { Caption, Title } from "./Texts";

export default function MethodesContactMSDemandeAppui() {
	const dispatch = useAppDispatch();

	const onRadioSelected = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					msContactDAOnly: e.target.value === "true",
				})
			);
		},
		[dispatch]
	);
	const { preferences } = useAppSelector((s) => s.expertise);

	if (!preferences) return null;

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Restriction de contact via MonSisra"} />
			</Grid>
			<Grid item>
				<Caption
					text={
						"MonSisra permet de créer des conversations classiques entre plusieurs professionnels de santé, ou bien de créer une demande d'appui" +
						" guidée entre un demandeur et une équipe ressource. En tant qu'équipe ressource, vous avez la possibilité d'accepter, ou non, d'être contacté via" +
						"des conversations classiques."
					}
				/>
			</Grid>
			<Grid item>
				<FormControl component="fieldset">
					<RadioGroup value={preferences.msContactDAOnly} onChange={onRadioSelected} name="radio-buttons-group">
						<FormControlLabel
							value={"false"}
							control={<Radio  id={"ms-contact-all"}/>}
							label={
								<Grid container alignItems={"center"} spacing={0.5}>
									<Grid item>Je souhaite pouvoir être contacté librement via une conversation MonSisra ou une Demande d'appui</Grid>
								</Grid>
							}
						/>
						<FormControlLabel
							value={"true"}
							control={<Radio id={'ms-contact-da'}/>}
							label={
								<Grid container alignItems={"center"} spacing={0.5} >
									<Grid item>Je souhaite imposer le mode demande d'appui à tous les utilisateurs qui me contactent via MonSisra</Grid>
								</Grid>
							}
						/>
					</RadioGroup>
				</FormControl>
			</Grid>
		</Grid>
	);
}
